import { render } from "./PurchaseOrderDetailsView.vue?vue&type=template&id=1bf002d4&scoped=true"
import script from "./PurchaseOrderDetailsView.vue?vue&type=script&lang=js"
export * from "./PurchaseOrderDetailsView.vue?vue&type=script&lang=js"

import "./PurchaseOrderDetailsView.vue?vue&type=style&index=0&id=1bf002d4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bf002d4"]])

export default __exports__